var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "app-hint" }, [
    _c(
      "button",
      {
        ref: "button",
        staticClass: "app-hint-button",
        class: { open: _vm.open },
        attrs: {
          type: "button",
          "aria-label": _vm.$ct("common.info"),
          "aria-expanded": _vm.open ? "true" : "false",
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.toggle()
          },
        },
      },
      [_c("w-fa", { attrs: { icon: "question-circle" } })],
      1
    ),
    _vm.open
      ? _c(
          "div",
          {
            ref: "popup",
            staticClass: "app-hint-popup",
            style: {
              top: `${_vm.top}px`,
              left: `${_vm.left}px`,
              width: `${_vm.width}px`,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _vm.title
              ? _c("div", { staticClass: "app-hint-title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ])
              : _vm._e(),
            _vm.text
              ? _c("div", { staticClass: "app-hint-text" }, [
                  _vm._v(_vm._s(_vm.text)),
                ])
              : _vm._e(),
            _vm._t("default"),
            _vm.linkTo
              ? _c(
                  "w-link",
                  {
                    staticClass: "app-hint-link",
                    attrs: { to: _vm.linkTo },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.linkText || _vm.$ct("common.show-more-info"))
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }